<div class="download">
    <p>Downloading file</p>
    {{ this.route.snapshot.params.fileId }}
    <a class="download-link" #downloadLink></a>
</div>
